import { render, staticRenderFns } from "./Share-Service-Report-Mail.vue?vue&type=template&id=48517a63&"
import script from "./Share-Service-Report-Mail.vue?vue&type=script&lang=js&"
export * from "./Share-Service-Report-Mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports